import { cn } from "@/helpers/tailwind";
import dayjs from "dayjs";
import React from "react";

interface NewBattleLabelProps {
  className?: string;
  createdAt?: number;
}

export const NewBattleLabel: React.FC<NewBattleLabelProps> = ({
  className,
  createdAt,
}) =>
  createdAt &&
  dayjs().diff(dayjs(createdAt * 1000), "day") <= 2 && (
    <span
      className={cn(
        "bg-gradient-to-r from-[#E7C9FF] via-[#DAA4FD] to-[#A18FFC]",
        "bg-clip-text text-xs font-black text-transparent md:text-lg",
        className
      )}>
      NEW
    </span>
  );
